import { React, useState } from 'react';
import { AccordionBodyItem } from 'component/Accordion';

export const WaterArea = (props) => {
  const landuse = props.formData.info.landuse_and_beneficiaries;
  const [inputValue, setInputValue] = useState(String(landuse.land_water ?? 0));

  const otherFieldsSum = props.checkPercent('land_water');
  const isDisabledByOthers = otherFieldsSum > 0;

  const commitValue = (num) => {
    const newValue = num > 0 ? 100 : 0;
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        landuse_and_beneficiaries: {
          ...prevFormData.info.landuse_and_beneficiaries,
          land_water: newValue,
        },
      },
    }));
    setInputValue(String(newValue));
  };

  const handleChange = (e) => {
    const val = e.target.value;
    if (val !== '' && !/^\d+$/.test(val)) return;
    const stripped = val.replace(/^0+(\d)/, '$1');
    const num = Number(stripped);
    if (num > 100) return;
    setInputValue(stripped);
  };

  const handleBlur = () => {
    const num = inputValue === '' ? 0 : Number(inputValue);
    commitValue(num);
  };

  return (
    <div>
      <AccordionBodyItem
        accordionSubId={
          <div>
            <span>8.7</span>
            <span className="star">*</span>
          </div>
        }
        titleUA="Акваторії"
        titleEN="Water Area"
        children={
          <div className="flex-group">
            <input
              placeholder="0"
              id="land_water"
              name="land_water"
              className="number"
              value={inputValue}
              autoComplete="off"
              disabled={isDisabledByOthers}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <span>%</span>
          </div>
        }
      />
      <div className="text" style={{ fontSize: '0.6em', marginBottom: '10px' }}>
        <div>
          Must be equal to 0% or 100%. If the area includes both water bodies and other land-use
          types, it must be split into two separate reports.
        </div>
        <div>
          Має дорівнювати 0% або 100%. Якщо ділянка включає і акваторії, і інші типи
          землекористування, її потрібно розділити на два окремі звіти.
        </div>
      </div>
    </div>
  );
};
